<template>
  <div
    :id="id"
    class="modal-title-list-view"
  >
    <p class="title">Title</p>

    <div class="form-group">
      <input
        v-model="dataSetup.title"
        placeholder="Title Page"
        type="text"
      >
    </div>

    <div class="d-flex justify-content-end mt-4">
      <button
        class="button-border mr-2"
        @click="$emit('close-modal')"
      >
        Close
      </button>
      <button
        :disabled="!dataSetup.title"
        class="button-blue"
        @click="submitForm"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    data: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dataSetup: {
        title: null,
      },
    };
  },

  created() {
    if (this.data) this.dataSetup.title = this.data;
  },

  methods: {
    submitForm() {
      this.$emit('submit', this.dataSetup.title);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalTitleListView.vue